module.exports = __webpack_public_path__ + "static/img/banner_3.606abce0.webp";